/***
**Module Name: header
 **File Name :  header.js
 **Project :    Dadi
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  Kiran Kumar
 **author :  Mani Kanta
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: 2025-04-22
 **Last modified on: Dec 29 2022
 **Description : contains header details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import * as Config from "../../constants/Config";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import logo from '../../assets/images/Dadi-logo.svg'
import { contentContext } from "../../context/contentContext";

const Header = ({ fn }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [image, setImg] = useState('');
    const [data, setData] = useState("");
    const [userName, setUserName] = useState([]);

    const { setShowPopup, setSelectedOptions, setMultiSelectFields, setActiveFieldsObj, setActiveMenuObj,
        setSelectedOptionsClientName, setSearchPayload, setInitialCategoriesData1, toggleMenu, setToggleMenu, GetTimeActivity, userData, setUserData, userDataLoading } = useContext(contentContext)

    const handleProfile = (e) => {

        // GetTimeActivity();
        navigate("/profile");
    }

    const handleLogout = (e) => {
        // debugger
        // GetTimeActivity();
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("email");

        localStorage.removeItem("ClientName");
        localStorage.removeItem("ClientType");
        localStorage.removeItem('subscriptionPlanId')
        localStorage.clear();

        signoutsession();
        navigate("/");


    }

    // console.log('user edataaa',userData)
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }


    }, [window.site]);

    // useEffect(() => {
    //     const token = localStorage.getItem("token")
    //     const userid = localStorage.getItem("userId")
    //     if (token && userid) {
    //         GetUserData();
    //     }


    // }, []);



    const GetUserData = async () => {
        try {

            const response = await tmdbApi.getUserData();

            if (response?.statusCode === 200) {

                setUserData(response?.result?.[0]);

            }
        } catch {
            console.log("error");
        }
    };

    // useEffect(() => {
    //     if (!localStorage.getItem("token")) {
    //         navigate("/home")
    //     }
    // }, [])

    const signoutsession = async () => {
        try {
            const response = await tmdbApi.SignOutUser({ emailId: userData.emailid });
            console.log(response);

        } catch {
            console.log("error");
        }
    }
    const handleRedirect = () => {
        // GetTimeActivity();
        // let userArr = userData.permissions

        // console.log("userArr", userData)

        // const obj = userArr.reduce((acc, item) => {
        //     if (item.submenus) acc[item.menu] = false;
        //     return acc;
        // }, {});
        // // console.log('objjjjjjjj--->',obj)

        // let k = userData

        // let permissionList = userData && userData.permissions
        // let filterdList = permissionList.filter((item) => item.display == true)
        // let id = filterdList && filterdList[0] && filterdList[0].menu.split(" ").join("").toLowerCase()

        navigate("/");
    }

    //   let userName=[]
    //   userName = localStorage.getItem("ClientName")?.split(" ");

    const handleMenuToggle = () => {
        setToggleMenu(!toggleMenu)
    }

    return (
        <header id="page-topbar">
            <div className="navbar-header d-flex justify-content-between align-items-center px-3">
                {/* LEFT: Logo & Sidebar Toggle */}
                <div className="d-flex align-items-center gap-2">
                    <button type="button" className="btn btn-sm header-item waves-effect" id="vertical-menu-btn" onClick={handleMenuToggle}>
                        <i className="fa fa-fw fa-bars"></i>
                    </button>
                    <div className="navbar-brand-box">
                        <a onClick={handleRedirect} className="logo cursor-pointer">
                            <span className="logo-lg">
                                <img src={logo} alt="Logo" />
                            </span>
                        </a>
                    </div>
                </div>
                {location?.pathname?.toLowerCase().startsWith("/editmodulecase") ? null :
                    <div className="d-flex align-items-center gap-4">
                        {/* CENTER: Nav Links */}
                        <div className="nav-links-section dasboard-header-links">

                            <ul className="d-flex gap-3 mb-0">
                                {/* <li className="nav-item"><span className="nav-link">Dashboard</span></li> */}
                                <li className="nav-item">
                                    <span className={window.location.pathname === "/diagnostics" ? "nav-link active" : "nav-link"} onClick={() => navigate("/diagnostics")}>Diagnostics</span>
                                </li>
                                <li className="nav-item">
                                    <span className={window.location.pathname === "/learning" ? "nav-link active" : "nav-link"} onClick={() => navigate("/learning")}>Learning Hub</span>
                                </li>
                                <li className="nav-item">
                                    <span className={window.location.pathname === "/cpc" ? "nav-link active" : "nav-link"} onClick={() => navigate("/cpcregistration")}>CPC</span>
                                </li>
                                <li className="nav-item">
                                    <span className={window.location.pathname === "/fellowship" ? "nav-link active" : "nav-link"} onClick={() => navigate("/fellowship")}>Fellowship</span>
                                </li>
                                <li className="nav-item">
                                    <span className={window.location.pathname === "/about" ? "nav-link active" : "nav-link"} onClick={() => navigate("/about")}>About</span>
                                </li>
                                <li className="nav-item">
                                    <span className={window.location.pathname === "/contact" ? "nav-link active" : "nav-link"} onClick={() => navigate("/contact")}>Contact</span>
                                </li>
                            </ul>
                        </div>

                        {/* RIGHT: Profile */}
                        <div className="dropdown d-inline-block">
                            <button type="button" className="btn header-item waves-effect db-profile" id="page-header-user-dropdown"
                                data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">


                                <span className="profile_pic">
                                    {userDataLoading
                                        ? <span className="spinner-border spinner-border-sm" style={{ width: '14px', height: '14px', borderWidth: '2px' }} role="status" />
                                        : userData?.name?.slice(0, 2)?.toUpperCase()
                                    }
                                </span>


                                <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">

                                <a className="dropdown-item text-secondary" onClick={handleProfile}><i className="bx bx-user font-size-16 align-middle me-1"></i>
                                    <span key="t-profile">Profile</span></a>

                                <div className="dropdown-divider"></div>
                                {/* <a className="dropdown-item text-danger" onClick={handleLogout}><i
                                    className="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i> <span
                                        key="t-logout">Logout</span></a> */}
                                <a className="dropdown-item text-danger" onClick={handleLogout}>
                                    <i className="bx bx-power-off font-size-16 align-middle me-1"></i>
                                    <span key="t-logout">Logout</span>
                                </a>
                            </div>
                        </div>
                    </div>
                }

            </div>
        </header>

    );
};

export default Header;
